<div
  [formGroup]="formGroup"
  class="pssr-form-group">
  <div class="name-group">
    <div class="pssr-form-control">
      <label
        [class.ng-invalid]="isInvalidFirstName()"
        class="pssr-form-label">
        {{ 'externalUserForm.labels.firstName' | translate }}
      </label>
      <input
        [class.ng-invalid]="isInvalidFirstName()"
        [readonly]="isReadOnly()"
        formControlName="firstName"
        type="text"
        pInputText
        class="pssr-input" />
      @if (isInvalidFirstName()) {
        <small class="error-message">
          {{
            'app.forms.validation.required'
              | translate: { controlName: ('externalUserForm.labels.firstName' | translate) }
          }}
        </small>
      }
    </div>
    <div class="pssr-form-control">
      <label class="pssr-form-label">{{ 'externalUserForm.labels.lastName' | translate }}</label>
      <input
        [readonly]="isReadOnly()"
        formControlName="lastName"
        type="text"
        pInputText
        class="pssr-input" />
    </div>
  </div>
  <div class="pssr-form-control">
    <label
      [class.ng-invalid]="isInvalidEmail()"
      class="pssr-form-label">
      {{ 'externalUserForm.labels.email' | translate }}
    </label>
    <div class="email-input-row">
      <input
        [class.ng-invalid]="isInvalidEmail()"
        [readonly]="isReadOnly()"
        formControlName="email"
        type="text"
        pInputText
        class="pssr-input" />
      @if (actionTemplate()) {
        <ng-template [ngTemplateOutlet]="actionTemplate()!" />
      }
    </div>
    @if (isInvalidEmail()) {
      @if (formGroup.controls.email.errors?.['required']) {
        <small class="error-message">
          {{
            'app.forms.validation.required' | translate: { controlName: ('externalUserForm.labels.email' | translate) }
          }}
        </small>
      } @else {
        <small class="error-message">{{ 'app.forms.validation.invalidEmail' | translate }}</small>
      }
    }
  </div>
</div>
